export const localStorageCustomerTokenKey = `smartazminerals_customer_token`;
export const localStorageCartIdKey = `smartazminerals_cart_id`;
export const localStorageCartCodeKey = `smartazminerals_cart_discount_code`;
export const localStorageCartUrlKey = `smartazminerals_cart_checkout_url`;
